import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    remove: { type: Array, default: [] }
  };

  connect() {
    this.removeParams();
  }

  removeParams() {
    const url = new URL(window.location.href);
    const toRemove = this.removeValue.filter((name) => url.searchParams.has(name));
    if (toRemove.length === 0) return;

    toRemove.forEach((name) => url.searchParams.delete(name));
    history.replaceState({}, "", url);
  }
}
